// The one sentence for "the picked window reaches past the last complete report
// day". The picked window is THE window (URL, header, tiles, strip, table); the
// attributed table can only show reported days, so `to` is cut (partial) or, when
// no picked day is reported yet, the latest report day stands in (pending).
import type { DateWindow } from './dateRangeCompare'
import { fmtWindow } from './dateRangeCompare'
import { addDaysYMD, fmtMonthDay } from './format/date'

export type ReportGap =
  | { kind: 'complete' }
  | { kind: 'partial'; through: string; pending: DateWindow }
  | { kind: 'pending'; standIn: string; pending: DateWindow }

export function reportGap(pick: DateWindow, dataThrough: string | null): ReportGap {
  if (!dataThrough || pick.to <= dataThrough) return { kind: 'complete' }
  if (pick.from <= dataThrough) {
    return {
      kind: 'partial',
      through: dataThrough,
      pending: { from: addDaysYMD(dataThrough, 1), to: pick.to },
    }
  }
  return { kind: 'pending', standIn: dataThrough, pending: { from: pick.from, to: pick.to } }
}

export function reportGapSentence(g: ReportGap, thisYear: number): string | null {
  if (g.kind === 'partial') {
    return `Reports for ${fmtWindow(g.pending, thisYear)} are still coming in — showing through ${fmtMonthDay(g.through)}.`
  }
  if (g.kind === 'pending') {
    return `No report for ${fmtWindow(g.pending, thisYear)} yet — showing ${fmtMonthDay(g.standIn)}, the latest report day.`
  }
  return null
}

export function reportGapShort(g: ReportGap): string | null {
  if (g.kind === 'partial') return `through ${fmtMonthDay(g.through)}`
  if (g.kind === 'pending') return `showing ${fmtMonthDay(g.standIn)}`
  return null
}

export function tileGapNote(g: ReportGap, thisYear: number): string | null {
  if (g.kind === 'partial') {
    return `Reports through ${fmtMonthDay(g.through)} · ${fmtWindow(g.pending, thisYear)} live`
  }
  if (g.kind === 'pending') return `No report for ${fmtWindow(g.pending, thisYear)} yet · live`
  return null
}
